// Button label -> Tag_Definitions.tag_key. Only buttons migrated to the generic
// /game/tagclips endpoint appear here; the rest fall through to their original
// per-button service methods.
//
// Keys are the English label strings the button list and i18n both use, so they
// stay as-is even when the displayed text is retranslated.
export const TAG_KEYS = {
    'Started From Goalkeeper': 'goalkeeper_distribution',
    'All Offensive Possessions': 'all_offensive_possessions',
    'All Defensive Possessions': 'all_defensive_possessions',
    'Build Up Own Half': 'build_up_under_pressure',
    'Started From Throw In': 'started_from_throw_in',
    'Started From Interception': 'started_from_interception',
    'Started From Tackle': 'started_from_tackle',
    'Build Up Opponent Half': 'attack',
    'Counter-Attacks': 'counter_attacks',
    'Started From Free Kicks': 'started_from_free_kick',
    'Started From Corners': 'started_from_corner',
    'Possessions With Goals': 'possessions_with_goals',
    'Possessions That Draw Penalty': 'possessions_drawing_penalty',
    'Counter Attack after pass interception': 'counter_attack_after_interception',
    'Counter Attack after 1v1': 'counter_attack_after_1v1',
    'Kick-Offs': 'kick_offs',
    'All Transitions from Defense to Attack': 'transitions_defense_to_attack',
    'Started from successful 1v1 and become chance': 'started_from_1v1_to_chance',
    'Game Highlight': 'game_highlight',
    'Clean Game': 'clean_game'
};

// True when a clip came from the generic /game/tagclips endpoint and therefore
// carries the discrete first/last action columns buildClipName needs.
//
// Call sites use this to opt in: if it returns false the clip came from one of
// the Individual Actions buttons, which still use their own endpoints, and that
// site must keep its existing label format byte-for-byte. That is what stops this
// change leaking into buttons it was never meant to touch.
export const hasClipNameColumns = (clip) => Boolean(clip && clip.first_player_name && String(clip.first_player_name).trim());

// Clip label: team, the possession's opening action, then the possessing team's
// closing action. Falls back to the aggregate columns for clips coming from
// endpoints that have not been migrated yet.
export const buildClipName = (clip) => {
    const join = (...parts) => parts.filter((part) => part && String(part).trim()).join(' - ');

    const opening = join(
        clip.first_player_name,
        clip.first_action_name,
        clip.first_action_type_name,
        clip.first_action_result_name
    );

    if (!opening) {
        const playerName = clip.player_names || clip.player_name || clip.started_player_name || '';
        const actionName = clip.action_names || clip.action_name || clip.started_action_name || '';
        const actionTypeName = clip.action_type_names || clip.action_type_name || clip.started_action_type_name || '';
        const actionResultName = clip.action_result_names || clip.action_result_name || clip.started_action_result_name || '';

        return join(playerName, actionName, actionTypeName, actionResultName);
    }

    // Only emit the closing segment when it has a player or action to anchor it -
    // a bare type/result pair with no player_name/action_name isn't a real closing
    // action, it's leftover fields from a possession with no team action after the
    // keeper.
    const hasClosingAction =
        (clip.last_player_name && String(clip.last_player_name).trim()) ||
        (clip.last_action_name && String(clip.last_action_name).trim());

    const closing = hasClosingAction
        ? join(clip.last_player_name, clip.last_action_name, clip.last_action_type_name, clip.last_action_result_name)
        : '';

    return [clip.team_name, opening, closing].filter((part) => part && part.trim()).join(' | ');
};

export default TAG_KEYS;
